import { useEffect } from 'react'
import { type Href, useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { GateFallback } from '@/components/ui/GateFallback'

/**
 * Moves a stale Preview deep link into the fixture-only route family after
 * the current native scene has committed.  A render-time redirect across two
 * stack groups can make Fabric try to attach the outgoing scene's child twice
 * on Android; the one-frame handoff preserves isolation without that race.
 */
export function PreviewFixtureRedirect({ href }: { href: string }) {
  const router = useRouter()
  const { t } = useTranslation()

  useEffect(() => {
    const frame = requestAnimationFrame(() => router.replace(href as Href))
    return () => cancelAnimationFrame(frame)
  }, [href, router])

  return <GateFallback accessibilityLabel={t('common.loading')} testID="preview.fixture-redirect" />
}
